import 'slick-carousel';

(function (slider, $, undefined) {

    // public configuration variable
    slider.config = {};

    // bind events and such to the DOM
    // private function
    function bindEvents() {
        $(window).on('load', function () {
            homeSliders();
        });

        $(window).on('resize', function () {
            
        });
    }

    var homeSliders = function () {
        var $mainSlider = $(".main-slider");
        var $navSlider = $(".nav-slider");
        var $reviewSlider = $(".review-slider");

        $mainSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.nav-slider'
        });

        $navSlider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.main-slider',
            dots: false,
            nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
            prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            focusOnSelect: true,
            responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 970,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 1,
                }
            }
            ]
        });

        $reviewSlider.slick({
        	autoplay: true,
        	autoplaySpeed: 8000,
            dots: true,
            nextArrow: '<i class="fa fa-angle-right next" aria-hidden="true"></i>',
            prevArrow: '<i class="fa fa-angle-left prev" aria-hidden="true"></i>',
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: true
        });
    }

    // initialize object
    // this is a public function
    slider.init = function () {
        bindEvents();
    }
})(window.slider = window.slider || {}, jQuery);

// self initialize once the DOM is loaded
(function ($) {
    slider.init();
}(jQuery));



// WEBPACK FOOTER //
// ./Content/js/app/slider.js